import {
  USERS_FILTER_FETCH_STARTED,
  USERS_FILTER_FETCH_SUCCEEDED,
  USERS_FILTER_FETCH_FAILED,
  USERS_FILTER_SET_FILTER,
  USERS_FILTER_CLEAR,
  USERS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  users: [],
  projects: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: 'firstName',
  filter: [],
  selectedFilter: [],
  filterBy: ['fullName']
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USERS_FILTER_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case USERS_FILTER_FETCH_SUCCEEDED:
      const { users, projects } = action.payload;
      return {
        ...state,
        users,
        projects,
        status: statuses.succeeded,
        totalCount: action.totalCount
      };
    case USERS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED:
      return {
        ...state,
        selectedFilter: action.payload
      };
    case USERS_FILTER_FETCH_FAILED:
      return { ...state, status: statuses.failed, users: [], projects: [], error: action.error };
    case USERS_FILTER_SET_FILTER:
      return { ...state, filter: action.payload };
    case USERS_FILTER_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
